<template>
  <div>
    <!--    Cabecera con parte del vídeo-->
    <section class="bg-primary py-5 bg-trama">
      <div class="container">
        <div class="row d-flex align-items-center">
          <div class="col-12 text-white my-5">
            <h1>Esto es… nuestro Retiro</h1>
          </div>

          <div class="col-12">
            <p class="subtitular text-white">
              Piensa en árboles frondosos, senderos, un estanque… ¿qué imagen te viene a la mente? Quizá sea el Retiro,
              pero una vez que conozcas la Sierra Norte de Madrid, ¡solo pensarás en nosotros!
              <strong
                >Siente la naturaleza como nunca esperaste hacerlo, ¡a solo una hora de distancia de Madrid!</strong
              >
            </p>
          </div>
          <div class="col-12 mt-4">
            <img
              src="/img/icons/naturaleza.svg"
              alt="Planes especiales para amantes de la naturaleza"
              class="mr-3"
            /><span class="text-black small">Planes especiales para amantes de la naturaleza</span>
          </div>
        </div>
      </div>
    </section>

    <!--      Fin de cabecera-->
    <!--      Sección con scroll horizontal-->

    <div id="scroll-wrapper" class="container-fluid scroll-wrapper bg-light">
      <div id="scrollContainer" class="scroll-sections">
        <div id="fondo-puntos" style="overflow: hidden;width:50px;position:absolute;height: 100vh;left:70vh">
          <img src="/img/caminos/camino-1.svg" alt="" style="position: absolute;top:30%;z-index:2" />
        </div>

        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <h2 class="mb-4">Vive el Madrid más salvaje e inesperado</h2>
            <p class="subtitular z-index-up">
              ¿Te gustaría despertar con el canto de los pinzones, avistar buitres y corzos, observar el cambio de
              tonalidad de las hojas de los árboles y terminar una ruta de senderismo bajo una impresionante cascada? Si
              la respuesta es “sí”, <strong>¡tenemos lo que estás buscando!</strong>
            </p>
            <a href="https://www.sierranortemadrid.org/restaurantes/" class="btn btn-primary mr-3 mt-2" target="_blank">
              ¿Dónde comer?
            </a>
            <a href="https://www.sierranortemadrid.org/alojamiento/" class="btn btn-primary mt-2" target="_blank">
              ¿Dónde alojarse?
            </a>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta3/hayedo.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Hayedo de Montejo</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      <a
                        href="https://www.sierranortemadrid.org/planes/hayedo-montejo"
                        target="_blank"
                        alt="Más información sobre el Hayedo"
                        >El Hayedo de Montejo</a
                      >
                      ha sido declarado <strong>Sitio Natural de Interés Nacional,</strong> ya que se trata de uno de
                      los bosques de hayas más meridionales de Europa.
                    </span>
                  </li>
                  <li>
                    <span>
                      Si quieres obtener un “pase de día” para visitar el Hayedo en esa misma jornada, debes dirigirte
                      al Centro de Información de la Reserva de la Biosfera de la Sierra del Rincón, en Montejo de la
                      Sierra.
                    </span>
                  </li>
                  <li>
                    <span>
                      Al tratarse de un espacio protegido, es importante que tengas presente que no puede visitarse con
                      mascota, así como que está prohibido salir del sendero trazado.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1-2h" />
                  <icon-primavera />
                  <icon-parejas />
                  <icon-familias />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Hayedo de Montejo</h3>
                <p>
                  Los colores del otoño y la vivacidad de la primavera, como nunca antes los habías disfrutado en
                  Madrid.
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal1 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1-2h" />
                  <icon-primavera />
                  <icon-parejas />
                  <icon-familias />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Inicio "2" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top mt-5 mt-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up">
                <img src="/img/rutas/ruta3/abedular-de-canencia.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Abedular de Canencia</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      Se encuentra en el Puerto de Canencia, uno de los puertos de montaña por los que se accede a la
                      Sierra Norte de Madrid, y
                      <strong>su espectacular paisaje está compuesto por tejos, acebos, robles, abedules,...</strong>
                    </span>
                  </li>
                  <li>
                    <span>
                      Para recorrer
                      <a
                        href="https://www.sierranortemadrid.org/senda-sestil-del-maillo-y-mojonavalle/"
                        target="_blank"
                        alt="Más información sobre el Abedular"
                        >el Abedular</a
                      >
                      existe una ruta que pasa también por el mirador de la Chorrera de Mojonavalle, un paraje de
                      singular belleza con un impresionante salto de agua.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="2h" />
                  <icon-primavera />
                  <icon-otono />
                  <icon-familia />
                  <icon-parejas />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Abedular de Canencia</h3>
                <p>¿Existe una luz más hermosa que la que se filtra entre los árboles de un bosque tupido?</p>
                <div class="mb-4">
                  <b-button v-b-modal.modal2 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="2h" />
                  <icon-primavera />
                  <icon-otono />
                  <icon-familia />
                  <icon-parejas />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta3/chorrera-de-san-mames.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Chorrera de San Mamés</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      <strong>¡Uno de los saltos de agua más altos de la Comunidad de Madrid!</strong> Para llegar hasta
                      <a
                        href="https://www.sierranortemadrid.org/chorrera-san-mames/"
                        target="_blank"
                        alt="Más información sobre la Chorrera"
                        >la Chorrera,</a
                      >
                      puedes ir por una ruta que discurre paralela al cauce del arroyo del chorro, adentrándose en un
                      bosque de pinos silvestre.
                    </span>
                  </li>
                  <li>
                    <span>
                      Te recomendamos parar en una quesería artesana que se encuentra a medio camino y probar uno de los
                      mejores quesos de la sierra.
                    </span>
                  </li>
                  <li>
                    <span>
                      No es recomendable hacer esta ruta con niños, ya que tiene una
                      <strong>subida bastante pronunciada.</strong>
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1h" />
                  <icon-foodies />
                  <icon-primavera />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Chorrera de San Mamés</h3>
                <p>¡No es necesario explorar lugares lejanos para ver cascadas impresionantes!</p>
                <div class="mb-4">
                  <b-button v-b-modal.modal3 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="1h" />
                  <icon-foodies />
                  <icon-primavera />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "2" slider ******************-->
        <!--          Inicio "3" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top mt-5 mt-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up">
                <img src="/img/rutas/ruta3/birding.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Birding en el Valle del Lozoya y la Sierra del Rincón</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      ¿Sabías que la Sierra Norte de Madrid es
                      <strong>uno de los mejores destinos ornitológicos de España?</strong> En la Comunidad de Madrid
                      existen más de 300 especies de aves distintas, y pueden observarse aves esteparias, aves acuáticas
                      y aves urbanas.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="3h" />
                  <icon-familias />
                  <icon-parejas />
                  <icon-primavera />
                  <icon-otono />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Birding en el Valle del Lozoya y la Sierra del Rincón</h3>
                <p>¿Sabías que la Sierra Norte de Madrid es uno de los mejores destinos ornitológicos de España?</p>
                <div class="mb-4">
                  <b-button v-b-modal.modal4 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="3h" />
                  <icon-familias />
                  <icon-parejas />
                  <icon-primavera />
                  <icon-otono />
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-5 offset-lg-1 mt-5 mt-lg-0">
            <div class="row">
              <div class="col-12 px-0 z-index-down">
                <img src="/img/rutas/ruta3/dehesa-somosierra.jpg" alt="" class="img-fluid" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none">
                <h3 class="mt-5 mb-3">Dehesa Bonita de Somosierra</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      Ruta senderista desde el pueblo de Somosierra, que
                      <strong
                        ><a
                          href="https://www.sierranortemadrid.org/dehesa-bonita/"
                          target="_blank"
                          alt="Más información sobre la Dehesa Bonita"
                          >atraviesa prados y arboledas</a
                        ></strong
                      >
                      (acebos, robles, cerezos, avellanos y, sobre todo, abedules), y en la que
                      <strong>es posible avistar vacas y bueyes.</strong>
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="2h" />
                  <icon-primavera />
                  <icon-otono />
                  <icon-familias />
                  <icon-parejas />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Dehesa Bonita de Somosierra</h3>
                <p>Conecta con la naturaleza (y contigo mismo) rodeado de árboles centenarios…¡y nada más!</p>
                <div class="mb-4">
                  <b-button v-b-modal.modal5 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="2h" />
                  <icon-primavera />
                  <icon-otono />
                  <icon-familias />
                  <icon-parejas />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "3" slider ******************-->

        <!--          Inicio "4" slider************-->
        <div class="row scroll-section d-flex align-items-center">
          <div class="col-lg-5 offset-lg-1 z-index-top my-5 my-lg-0">
            <div class="row flex-lg-column-reverse">
              <div class="col-12 px-0 z-index-up ">
                <img src="/img/rutas/ruta3/bosque-de-acebos.jpg" alt="" class="img-fluid mt-0 mt-lg-3" />
              </div>
              <!--              Capa visible Movil-->
              <div class="col-lg-10 z-index-up d-lg-none mb-4">
                <h3 class="mt-5 mb-3">Bosque de acebos de Robregordo</h3>
                <ul class="actividades">
                  <li>
                    <span>
                      Esta ruta nos permite descubrir
                      <strong>uno de los tesoros botánicos de la Sierra Norte: </strong
                      ><a
                        href="https://www.sierranortemadrid.org/circular-dehesa-acebos/"
                        target="_blank"
                        alt="Más información sobre la dehesa"
                        >la dehesa de acebos de Robregordo.</a
                      >
                      Atraviesa el Área Recreativa El Plantío, un área de descanso con zona de merienda, columpios,
                      mesas y fuente, al lado del río Madarquillos. Un lugar ideal para pasar un estupendo día de campo
                      tras realizar la ruta por el bosque de acebos.
                    </span>
                  </li>
                  <li>
                    <span>
                      Es importante recordar que <strong>el acebo está protegido</strong> en la región, por lo que queda
                      estrictamente prohibido dañar las plantas o cortar la menor rama.
                    </span>
                  </li>
                </ul>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="3h" />
                  <icon-parejas />
                  <icon-influencers />
                  <icon-todas-estaciones />
                </div>
              </div>
              <!--              Capa visible Escritorio-->
              <div class="col-lg-10 z-index-up d-none d-lg-block">
                <h3 class="mt-5 mb-3">Bosque de acebos de Robregordo</h3>
                <p>
                  ¿Tu época favorita es la Navidad? ¡Disfruta de un paisaje navideño inigualable en nuestra dehesa de
                  acebos!
                </p>
                <div class="mb-4">
                  <b-button v-b-modal.modal6 variant="secondary">Más información</b-button>
                </div>
                <div class="row iconos-actividades d-flex justify-content-center justify-content-lg-start">
                  <icon-time duration="3h" />
                  <icon-parejas />
                  <icon-influencers />
                  <icon-todas-estaciones />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--          Fin "4" slider ******************-->
      </div>
    </div>
    <!--    Fin sección scroll horizontal-->
    <!--    Inicio modals-->

    <!--   Inicio Modal 1-->
    <b-modal id="modal1" centered scrollable size="lg" hide-footer title="Hayedo de Montejo">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <a
                  href="https://www.sierranortemadrid.org/planes/hayedo-montejo"
                  target="_blank"
                  alt="Más información sobre el Hayedo"
                  >El Hayedo de Montejo</a
                >
                ha sido declarado <strong>Sitio Natural de Interés Nacional,</strong> ya que se trata de uno de los
                bosques de hayas más meridionales de Europa.
              </span>
            </li>
            <li>
              <span>
                Si quieres obtener un “pase de día” para visitar el Hayedo en esa misma jornada, debes dirigirte al
                Centro de Información de la Reserva de la Biosfera de la Sierra del Rincón, en Montejo de la Sierra.
              </span>
            </li>
            <li>
              <span>
                Al tratarse de un espacio protegido, es importante que tengas presente que no puede visitarse con
                mascota, así como que está prohibido salir del sendero trazado.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 1-->
    <!--   Inicio Modal 2-->
    <b-modal id="modal2" centered scrollable size="lg" hide-footer title="Abedular de Canencia">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                Se encuentra en el Puerto de Canencia, uno de los puertos de montaña por los que se accede a la Sierra
                Norte de Madrid, y
                <strong>su espectacular paisaje está compuesto por tejos, acebos, robles, abedules,...</strong>
              </span>
            </li>
            <li>
              <span>
                Para recorrer
                <a
                  href="https://www.sierranortemadrid.org/senda-sestil-del-maillo-y-mojonavalle/"
                  target="_blank"
                  alt="Más información sobre el Abedular"
                  >el Abedular</a
                >
                existe una ruta que pasa también por el mirador de la Chorrera de Mojonavalle, un paraje de singular
                belleza con un impresionante salto de agua.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 2-->
    <!--   Inicio Modal 3-->
    <b-modal id="modal3" centered scrollable size="lg" hide-footer title="Chorrera de San Mamés">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                <strong>¡Uno de los saltos de agua más altos de la Comunidad de Madrid!</strong> Para llegar hasta
                <a
                  href="https://www.sierranortemadrid.org/chorrera-san-mames/"
                  target="_blank"
                  alt="Más información sobre la Chorrera"
                  >la Chorrera,</a
                >
                puedes ir por una ruta que discurre paralela al cauce del arroyo del chorro, adentrándose en un bosque
                de pinos silvestre.
              </span>
            </li>
            <li>
              <span>
                Te recomendamos parar en una quesería artesana que se encuentra a medio camino y probar uno de los
                mejores quesos de la sierra.
              </span>
            </li>
            <li>
              <span>
                No es recomendable hacer esta ruta con niños, ya que tiene una
                <strong>subida bastante pronunciada.</strong>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 3-->
    <!--   Inicio Modal 4-->
    <b-modal
      id="modal4"
      centered
      scrollable
      size="lg"
      hide-footer
      title="Birding en el Valle del Lozoya y la Sierra del Rincón"
    >
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                En la Comunidad de Madrid existen más de 300 especies de aves distintas, y pueden observarse aves
                esteparias, aves acuáticas y aves urbanas.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 4-->
    <!--   Inicio Modal 5-->
    <b-modal id="modal5" centered scrollable size="lg" hide-footer title="Dehesa Bonita de Somosierra">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                Ruta senderista desde el pueblo de Somosierra, que
                <strong
                  ><a
                    href="https://www.sierranortemadrid.org/dehesa-bonita/"
                    target="_blank"
                    alt="Más información sobre la Dehesa Bonita"
                    >atraviesa prados y arboledas</a
                  ></strong
                >
                (acebos, robles, cerezos, avellanos y, sobre todo, abedules), y en la que
                <strong>es posible avistar vacas y bueyes.</strong>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 5-->
    <!--   Inicio Modal 6-->
    <b-modal id="modal6" centered scrollable size="lg" hide-footer title="Bosque de acebos de Robregordo">
      <div class="container">
        <div class="row">
          <ul class="actividades">
            <li>
              <span>
                Esta ruta nos permite descubrir
                <strong>uno de los tesoros botánicos de la Sierra Norte: </strong
                ><a
                  href="https://www.sierranortemadrid.org/circular-dehesa-acebos/"
                  target="_blank"
                  alt="Más información sobre la dehesa"
                  >la dehesa de acebos de Robregordo.</a
                >
                Atraviesa el Área Recreativa El Plantío, un área de descanso con zona de merienda, columpios, mesas y
                fuente, al lado del río Madarquillos. Un lugar ideal para pasar un estupendo día de campo tras realizar
                la ruta por el bosque de acebos.
              </span>
            </li>
            <li>
              <span>
                Es importante recordar que <strong>el acebo está protegido</strong> en la región, por lo que queda
                estrictamente prohibido dañar las plantas o cortar la menor rama.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </b-modal>
    <!--    Fin Modal 6-->
    <!--    Fin de modal-->
  </div>
</template>

<script>
import { TimelineMax } from 'gsap'

export default {
  components: {
    IconTime: () => import('../../components/iconos/IconTime'),
    // IconCulturetas: () => import('../../components/iconos/IconCulturetas'),
    // IconVerano: () => import('../../components/iconos/IconVerano'),
    // IconDistance: () => import('../../components/iconos/IconDistance'),
    IconFamilias: () => import('../../components/iconos/IconFamilias'),
    IconFoodies: () => import('../../components/iconos/IconFoodies'),
    IconInfluencers: () => import('../../components/iconos/IconInfluencers'),
    // IconInvierno: () => import('../../components/iconos/IconInvierno'),
    IconOtono: () => import('../../components/iconos/IconOtono'),
    IconParejas: () => import('../../components/iconos/IconParejas'),
    IconPrimavera: () => import('../../components/iconos/IconPrimavera'),
    IconTodasEstaciones: () => import('../../components/iconos/IconTodasEstaciones')
    // IconAventureros: () => import('../../components/iconos/IconAventureros')
  },
  mounted() {
    if (window.innerWidth > 1000) {
      const horizontalSlide = new TimelineMax().to('#scrollContainer', 1, { x: '-50%' })
      const scene = this.$scrollmagic
        .scene({
          triggerElement: '#scroll-wrapper',
          triggerHook: 'onLeave',
          duration: '300%'
        })
        .setPin('#scroll-wrapper')
        .setTween(horizontalSlide)
      const scene2 = this.$scrollmagic
        .scene({
          triggerElement: '#scroll-wrapper',
          triggerHook: 'onLeave',
          duration: '300%'
        })
        .setTween('#fondo-puntos', {
          width: '60%'
        })

      this.$scrollmagic.addScene(scene)
      this.$scrollmagic.addScene(scene2)
    }
  }
}
</script>
